import type { RefThesaurus, RefThesaurusVersion } from '@/models/oru_collecte.types';

/**
 * Ligne renvoyée par le flow : un thésaurus et sa version active (champs `null` s'il n'en a pas).
 * Le `nb_valeurs` (count SQL, bigint) arrive sous forme de chaîne.
 */
export type ThesaurusRow = Pick<
  RefThesaurus,
  'id' | 'nom' | 'description' | 'documentation_url'
> & {
  version_id: RefThesaurusVersion['id'] | null;
  version: RefThesaurusVersion['version'] | null;
  date_heure_debut_validite: RefThesaurusVersion['date_heure_debut_validite'];
  source_url: RefThesaurusVersion['source_url'];
  nb_valeurs: string | null;
};

/** Colonnes triables côté client. */
export const thesaurusSortColumns = [
  'nom',
  'version',
  'nb_valeurs',
  'date_heure_debut_validite',
] as const satisfies readonly (keyof ThesaurusRow)[];

export type ThesaurusSortColumn = (typeof thesaurusSortColumns)[number];
